export default __webpack_public_path__ + "static/media/DigitalOcean.121b6473.svg";